import apiClient from "../services/apiClient";

// Fetch images 
export const fetchImages = async () => {
  const response = await apiClient.get("/api/Image/list");
  return response.data;
};

// Upload a new image
export const uploadImage = async (formData) => {
  const response = await apiClient.post("/api/Image/Add", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// Update an image
export const updateImage = async (id, formData) => {
  const response = await apiClient.put(`/api/Image/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// Delete an image
export const deleteImage = async (id) => {
  const response = await apiClient.delete(`/api/Image/${id}`);
  return response.data;
};

// Fetch image types
export const fetchImageTypes = async () => {
  const response = await apiClient.get("/api/image/types");
  return response.data;
};

// Fetch User By ID 
export const fetchUserByID = async (id) => {
  const response = await apiClient.get(`/api/User/${id}`);
  return response.data;
};

// Fetch users with optional role and search query
export const fetchUsers = async (role = "", search = "") => {
  const params = {};
  if (role) params.role = role;
  if (search) params.search = search;

  const response = await apiClient.get(`/api/User/search`, { params });
  return response.data.map((user) => ({
    id: user.id,
    username: user.username,
    firstName: user.firstName,
    lastName: user.lastName,
  }));
};